import {
  TablePagination as Mui4TablePagination,
  TablePaginationProps as Mui4TablePaginationProps,
} from '@material-ui/core'
import {
  default as Mui5TablePagination,
  TablePaginationProps as Mui5TablePaginationProps,
} from '@mui/material/TablePagination'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'
import {
  ActionsComponent,
  DisplayRowsComponent,
  NextButton,
  PreviousButton,
  StyledStartActionComponent,
  StyledTablePaginationMainWrapper,
  StyledTablePaginationWrapper,
} from '../other/tablePagination/TablePaginationWrapper'

export enum OsTablePaginationVersion {
  V1 = 1, // MUI4 + OS Theme
  V2 = 2, // MUI5 + Stratis
}

export type TablePaginationProps = Mui5TablePaginationProps & {
  startActionComponent?: React.ReactNode
  onRangeChange?: (index: number) => void
}

export const TablePagination = forwardRef<HTMLTableSectionElement, TablePaginationProps>((props, ref) => {
  const version = useComponentVersion('table_pagination')

  const {
    rowsPerPage,
    onRangeChange,
    startActionComponent,
    rowsPerPageOptions,
    onRowsPerPageChange,
    onPageChange,
  } = props

  switch (version) {
    case OsTablePaginationVersion.V2:
      return (
        <StyledTablePaginationWrapper
          className="OSUI-TablePaginationWrapper"
          startActionComponent={props.startActionComponent}
        >
          {startActionComponent && <StyledStartActionComponent>{startActionComponent}</StyledStartActionComponent>}
          <StyledTablePaginationMainWrapper>
            <ActionsComponent
              rowsPerPageOptions={rowsPerPageOptions ? [...rowsPerPageOptions] : []}
              onRowsPerPageChange={(x) => {
                onRowsPerPageChange?.(x)
                onRangeChange?.(0)
              }}
              rowsPerPage={rowsPerPage}
            />
            <Mui5TablePagination
              labelDisplayedRows={(paginationInfo) => {
                return (
                  <DisplayRowsComponent {...paginationInfo} rowsPerPage={rowsPerPage} onRangeChange={onRangeChange} />
                )
              }}
              slots={{
                ...props.slots,
                actions: {
                  nextButton: NextButton,
                  previousButton: PreviousButton,
                },
              }}
              ref={ref}
              {...props}
              rowsPerPageOptions={[]}
            />
          </StyledTablePaginationMainWrapper>
        </StyledTablePaginationWrapper>
      )
    default:
      return (
        <Mui4TablePagination
          {...((props as unknown) as Mui4TablePaginationProps)}
          onChangePage={onPageChange}
          onChangeRowsPerPage={onRowsPerPageChange}
          ref={ref}
        />
      )
  }
})
